module.exports = __webpack_public_path__ + "static/under-a-berlin-bridge_2017-66lx127wcm-acrylic-canvas-11062c9a678dfb123bd32a0c4cb69411.jpg";